import React from 'react';

interface ScoreRingProps {
  score: number;
  size?: number;
  strokeWidth?: number;
  showLabel?: boolean;
  className?: string;
}

function getScoreColor(score: number): string {
  if (score > 50) return 'var(--positive)';
  if (score >= 35) return 'var(--warning)';
  return 'var(--negative)';
}

export default function ScoreRing({
  score,
  size = 80,
  strokeWidth = 6,
  showLabel = true,
  className = '',
}: ScoreRingProps) {
  const radius = (size - strokeWidth * 2) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (score / 100) * circumference;
  const color = getScoreColor(score);
  const cx = size / 2;
  const cy = size / 2;

  return (
    <div data-component-id="src/components/ui/ScoreRing.tsx:32:4" data-component-path="src/components/ui/ScoreRing.tsx" data-component-line="32" data-component-end-line="72" data-component-file="ScoreRing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`relative inline-flex items-center justify-center ${className}`}>
      <svg data-component-id="src/components/ui/ScoreRing.tsx:33:6" data-component-path="src/components/ui/ScoreRing.tsx" data-component-line="33" data-component-end-line="53" data-component-file="ScoreRing.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle data-component-id="src/components/ui/ScoreRing.tsx:34:8" data-component-path="src/components/ui/ScoreRing.tsx" data-component-line="34" data-component-end-line="41" data-component-file="ScoreRing.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D"
          cx={cx}
          cy={cy}
          r={radius}
          fill="none"
          stroke="var(--muted)"
          strokeWidth={strokeWidth}
        />
        <circle data-component-id="src/components/ui/ScoreRing.tsx:42:8" data-component-path="src/components/ui/ScoreRing.tsx" data-component-line="42" data-component-end-line="52" data-component-file="ScoreRing.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D"
          cx={cx}
          cy={cy}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${progress} ${circumference}`}
          strokeLinecap="round"
          style={{ transition: 'stroke-dasharray 0.6s ease' }}
        />
      </svg>
      {showLabel && (
        <div data-component-id="src/components/ui/ScoreRing.tsx:55:8" data-component-path="src/components/ui/ScoreRing.tsx" data-component-line="55" data-component-end-line="70" data-component-file="ScoreRing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20flex%20flex-col%20items-center%20justify-center%22%7D" className="absolute inset-0 flex flex-col items-center justify-center">
          <span data-component-id="src/components/ui/ScoreRing.tsx:56:10" data-component-path="src/components/ui/ScoreRing.tsx" data-component-line="56" data-component-end-line="61" data-component-file="ScoreRing.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-bold%20tabular-nums%22%7D"
            className="font-bold tabular-nums"
            style={{ fontSize: size * 0.22, color }}
          >
            {score}
          </span>
          {size >= 80 && (
            <span data-component-id="src/components/ui/ScoreRing.tsx:63:12" data-component-path="src/components/ui/ScoreRing.tsx" data-component-line="63" data-component-end-line="68" data-component-file="ScoreRing.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-muted-foreground%20font-medium%22%2C%22textContent%22%3A%22%2F100%22%7D"
              className="text-muted-foreground font-medium"
              style={{ fontSize: size * 0.1 }}
            >
              /100
            </span>
          )}
        </div>
      )}
    </div>
  );
}